import {ROOT_REQUEST} from '@/assets/configs'

//选择物流园
export const GET_LOGISTIC_PARKS = `${ROOT_REQUEST.YUANQU}sc/v001/shop/getLogisticParks`

//上传多张轮播图片
export const UPLOAD = `${ROOT_REQUEST.YUANQU}sc/v001/ftp/upload`

//APP新增物流公司
export const ADD_COMPANY = `${ROOT_REQUEST.YUANQU}app/otms/addCompany`

//APP新增网点
export const SAVE_ORGANIZATION_LIST = `${ROOT_REQUEST.YUANQU}app/otms/saveOrganizationList`

//APP修改入驻信息
export const GET_COMPANY_AND_ORGANIZATION_INFO = `${ROOT_REQUEST.YUANQU}app/otms/getCompanyAndOrganizationInfo`

//APP获取下拉网点列表信息
export const GET_COMPANY_TMP_ORANGIZATIONS = `${ROOT_REQUEST.YUANQU}app/otms/getTmpOrganizations`

//APP新增路线
export const SAVE_ROUTE_LINE_LIST = `${ROOT_REQUEST.YUANQU}app/otms/saveRouteLineList`

//APP获取路线接口
export const GET_TMP_ROUTE_LINES = `${ROOT_REQUEST.YUANQU}app/otms/getTmpRouteLines`

//APP根据CODE获取经纬度
export const GET_LOCATION_BY_CITY_CODE= `${ROOT_REQUEST.YUANQU}park/getLocationByCityCode`

//APP获取消息列表
export const GET_APPLET_MESSAGE_LIST= `${ROOT_REQUEST.YUANQU}appletMessage/getAppletMessageList`

//APP获取消息列表
export const GET_APPLET_MESSAGE_DETAIL= `${ROOT_REQUEST.YUANQU}appletMessage/getAppleMessageDetail`

//APP获取园区列表
export const GET_PARKDISTRICTCODEWITHTICKET = `${ROOT_REQUEST.YUANQU}park/getParkByDistrictCode`

//APP园区发布招商
export const ADD_ZHAOSHANGCONF = `${ROOT_REQUEST.YUANQU}scm/v001/logisitcsZhaoShang/addZhaoShangConfForApp`

//动态菜单配置
export const LOGISTIC_INDEX_CONFIG_LIST = `${ROOT_REQUEST.YUANQU}v001/logisticCompany/logisticIndexConfigList`